/**
 * Shared mixin for promotion allocation area cell renderers.
 * Provides the AG-Grid `params` prop and a computed colour class
 * based on the promotion's effectiveness rating.
 */
export default {
    props: ['params'],
    computed: {
        colourClass() {
            const { effectivenessRating } = this.params?.data || {};
            if (effectivenessRating) {
                return `promotion-allocation-area__border-colour--${effectivenessRating}`;
            }
            return '';
        },
    },
};
